<template>

    <td :class="[`table-column-${field}`, { 'd-none': !this.isVisible, 'centred': this.isCentred }]">
        <slot></slot>
    </td>

</template>

<script>
export default {
    name: 'DataTableColumn',
    props: {
        field: String,
        isVisible: {
            type: Boolean,
            default: true
        },
        isCentred: {
            type: Boolean,
            default: false
        }
    }
}
</script>
